// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pcat-form {
  width: 100%;
  min-width: 0;
}

.pcat-form__field {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.pcat-form__label {
  margin: 0 0 8px;
  font-size: 13px;
  font-weight: 500;
  color: #0F172A;
  line-height: 1.3;
}

.pcat-form__req {
  color: #EF4444;
}

.pcat-form .ant-form-item {
  margin-bottom: 0 !important;
}

.pcat-form .ant-form-item-label,
.pcat-form .ant-form-item-feedback-icon {
  display: none !important;
}

.pcat-form .ant-form-item-explain-error {
  font-size: 12px;
  margin-top: 4px;
}

.pcat-form .ant-input-affix-wrapper,
.pcat-form .ant-form-item-control-input-content > input.ant-input {
  box-sizing: border-box !important;
  width: 100% !important;
  height: 36px !important;
  min-height: 36px !important;
  margin: 0 !important;
  padding: 0 12px !important;
  border: 1px solid #CBD5E1 !important;
  border-radius: 6px !important;
  background: #ffffff !important;
  box-shadow: none !important;
  font-size: 13px !important;
  font-weight: 400 !important;
  color: #0F172A !important;
}

.pcat-form .ant-input-affix-wrapper input.ant-input {
  height: 100% !important;
  min-height: 0 !important;
  padding: 0 !important;
  border: none !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  background: transparent !important;
}

.pcat-form .ant-input-affix-wrapper input.ant-input::placeholder,
.pcat-form .ant-form-item-control-input-content > input.ant-input::placeholder {
  color: #94A3B8;
}

.pcat-form .ant-input-affix-wrapper-focused,
.pcat-form .ant-input-affix-wrapper:focus-within,
.pcat-form .ant-form-item-control-input-content > input.ant-input:focus {
  border-color: #0EA5E9 !important;
  box-shadow: 0 0 0 1px #0EA5E9 !important;
}

.pcat-form .ant-form-item-has-error .ant-input-affix-wrapper,
.pcat-form .ant-form-item-has-error .ant-form-item-control-input-content > input.ant-input {
  border-color: #EF4444 !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/forms/inventory/productCategories/style.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;;EAEE,iCAAiC;EACjC,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,oBAAoB;EACpB,0BAA0B;EAC1B,oCAAoC;EACpC,6BAA6B;EAC7B,8BAA8B;EAC9B,2BAA2B;EAC3B,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,qBAAqB;EACrB,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;;EAGE,gCAAgC;EAChC,wCAAwC;AAC1C;;AAEA;;EAEE,gCAAgC;AAClC","sourcesContent":[".pcat-form {\n  width: 100%;\n  min-width: 0;\n}\n\n.pcat-form__field {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n}\n\n.pcat-form__label {\n  margin: 0 0 8px;\n  font-size: 13px;\n  font-weight: 500;\n  color: #0F172A;\n  line-height: 1.3;\n}\n\n.pcat-form__req {\n  color: #EF4444;\n}\n\n.pcat-form .ant-form-item {\n  margin-bottom: 0 !important;\n}\n\n.pcat-form .ant-form-item-label,\n.pcat-form .ant-form-item-feedback-icon {\n  display: none !important;\n}\n\n.pcat-form .ant-form-item-explain-error {\n  font-size: 12px;\n  margin-top: 4px;\n}\n\n.pcat-form .ant-input-affix-wrapper,\n.pcat-form .ant-form-item-control-input-content > input.ant-input {\n  box-sizing: border-box !important;\n  width: 100% !important;\n  height: 36px !important;\n  min-height: 36px !important;\n  margin: 0 !important;\n  padding: 0 12px !important;\n  border: 1px solid #CBD5E1 !important;\n  border-radius: 6px !important;\n  background: #ffffff !important;\n  box-shadow: none !important;\n  font-size: 13px !important;\n  font-weight: 400 !important;\n  color: #0F172A !important;\n}\n\n.pcat-form .ant-input-affix-wrapper input.ant-input {\n  height: 100% !important;\n  min-height: 0 !important;\n  padding: 0 !important;\n  border: none !important;\n  border-radius: 0 !important;\n  box-shadow: none !important;\n  background: transparent !important;\n}\n\n.pcat-form .ant-input-affix-wrapper input.ant-input::placeholder,\n.pcat-form .ant-form-item-control-input-content > input.ant-input::placeholder {\n  color: #94A3B8;\n}\n\n.pcat-form .ant-input-affix-wrapper-focused,\n.pcat-form .ant-input-affix-wrapper:focus-within,\n.pcat-form .ant-form-item-control-input-content > input.ant-input:focus {\n  border-color: #0EA5E9 !important;\n  box-shadow: 0 0 0 1px #0EA5E9 !important;\n}\n\n.pcat-form .ant-form-item-has-error .ant-input-affix-wrapper,\n.pcat-form .ant-form-item-has-error .ant-form-item-control-input-content > input.ant-input {\n  border-color: #EF4444 !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
